export default __webpack_public_path__ + "static/media/Order History-2.5a238e72.svg";